import React, { Component } from 'react'
import { get } from '@/utils/Integration.js';
export default class IntlTranslation extends Component {
  render() {
    return (
      <div>{get(this.props.intlkey)}</div>
    )
  }
}
